import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api, asList } from "@/lib/api";
import { allHistory, useAtsTick } from "@/lib/atsScores";

const WEEK = 7 * 864e5;

export const weeklyWins = (min) => Object.entries(allHistory()).flatMap(([jobId, h]) => {
  const i = h.findIndex((x, k) => k > 0 && x.score >= min && h[k - 1].score < min && Date.now() - new Date(x.at) < WEEK);
  return i > 0 ? [{ jobId, from: h[i - 1].score, to: h.at(-1).score, at: h[i].at }] : [];
}).sort((a, b) => b.at.localeCompare(a.at));

export const WinsCard = () => {
  const min = useAtsTick();
  const [jobs, setJobs] = useState({});
  useEffect(() => { api.get("/applications").then((r) => setJobs(Object.fromEntries(asList(r.data, "applications").map((a) => [a.job_id, a.job || {}])))).catch(() => {}); }, []);
  const wins = weeklyWins(min);
  return (
    <div className="mt-5 rounded-xl border border-[#27272A] bg-[#0F0F12] p-4" data-testid="wins-card">
      <div className="mb-2 flex items-center gap-2 text-sm text-zinc-200"><Trophy className="h-4 w-4 text-[#D4AF37]" />This week's wins<span className="ml-auto font-mono text-xs text-[#F3C649]" data-testid="wins-count">{wins.length}</span></div>
      {!wins.length ? <p className="text-xs text-zinc-500" data-testid="wins-empty">No job crossed your {min}% pass score in the last 7 days yet. Tailor a resume and re-check to land one.</p> : (
        <ul className="space-y-1.5">
          {wins.slice(0, 6).map((w) => (
            <li key={w.jobId} className="flex items-center gap-2 text-xs" data-testid={`win-${w.jobId}`}>
              <span className="min-w-0 flex-1 truncate text-zinc-300">{jobs[w.jobId]?.title || "Saved job"}{jobs[w.jobId]?.company && <span className="text-zinc-500"> · {jobs[w.jobId].company}</span>}</span>
              <span className="shrink-0 font-mono text-zinc-500">{w.from}%</span><span className="text-[#D4AF37]">→</span><span className="shrink-0 font-mono font-bold text-emerald-400">{w.to}%</span>
            </li>
          ))}
        </ul>
      )}
      <p className="mt-2 text-[11px] text-zinc-600">These also appear in your weekly score digest email.</p>
    </div>
  );
};
